import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";

const ERFPrintEwayBill = React.forwardRef((props, ref) => {
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store

  const [companyDetails, setCompanyDetails] = useState();

  const { data } = props;

  const printbody = {
    display: "flex",
    flexDirection: "column",
    margin: "10px",
  };

  const items = [
    ...(data?.saleItems || []),
    ...(data?.rentItems || []),
    ...(data?.serviceItems || []),
    ...(data?.nursingItems || []),
  ];

  const getCompanyDetails = async (id) => {
    try {
      const obj = {
        queryName: "Get_CompanyMaster_Details",

        documentNumber: id,
      };

      const res = await ItemServiceV2.generateCustomerQuery(obj);

      if (res?.status === 200 && res?.data) {
        const company = res.data?.[0];
        setCompanyDetails(company);
        // 🔹 Main form
        // setFormInputs(company);

        // // 🔹 Contact Persons
        // setcustomerContactPerson(company.contactDetails || []);

        // // 🔹 Documents
        // setDocumentTypeData(company.certifications || []);

        // // 🔹 Bank Details
        // // setBankDetails(company.bankDetails[0] || []);
        // setBankDetailsData(company.bankDetails[0] || []);

        // // 🔹 Company Profile
        // setCompanyProfile(company.companyProfile || {});
      }
    } catch (error) {
      console.error("Failed to load company details", error);
    }
  };
  useEffect(() => {
    getCompanyDetails(data?.companyNr);
  }, [data]);
  return (
    <div ref={ref} style={printbody} className="m-4">
      <Row>
        <Col
          xs={12}
          md={12}
          lg={12}
          className="d-flex justify-content-center align-items-end"
        >
          <Col xs={6} md={6} lg={6} className="d-flex justify-content-start">
            <img
              src={appConfig?.customerLogo1}
              alt="Bharthi_Cement_logo"
              className="introCustomerlogo"
            />
          </Col>
          <Col xs={6} md={6} lg={6} className="d-flex justify-content-start">
            <p className="fs-4 fw-bold"> E-Way Bill</p>
          </Col>
        </Col>
        <Col xs={12} md={12} lg={12} className="d-flex"></Col>
        <Col xs={12} md={12} lg={12} className="d-flex">
          <Col xs={1} md={1} lg={1}>
            <p className="fs-5 mb-0">Date</p>
          </Col>
          <Col xs={11} md={11} lg={11}>
            <p className="fs-5 fw-bold me-4 mb-0">: {data?.generatedDate}</p>
          </Col>
        </Col>
        {/* <Col xs={12} md={12} lg={12} className="d-flex">
          <Col xs={2} md={2} lg={2}>
            <p className="fs-5 mb-0">Ack Date</p>
          </Col>
          <Col xs={10} md={10} lg={10}>
            <p className="fs-5 fw-bold me-4 mb-0">: 2-Mar-25</p>
          </Col>
        </Col> */}
      </Row>
      <hr />
      <Row>
        <Col xs={12} md={12} lg={12} className="d-felx">
          <p className="fw-bold fs-5">1.E-way Bill Details</p>{" "}
        </Col>
        <Col xs={4} md={4} lg={4}>
          <p>
            {" "}
            E-way Bill No:{" "}
            <span className="fw-medium">{data?.e_WayBillNo}</span>
          </p>
        </Col>
        <Col xs={4} md={4} lg={4}>
          <p>
            {" "}
            Mode :<span className="fw-medium">{data?.mode} Road</span>{" "}
          </p>
        </Col>
        <Col xs={4} md={4} lg={4}>
          <p>
            Generate Date:
            <span className="fw-medium">{data?.generatedDate}</span>{" "}
          </p>
        </Col>
        <Col xs={4} md={4} lg={4}>
          <p>
            GeneratedBy:{" "}
            <span className="fw-medium">{data?.createdByName}</span>{" "}
          </p>
        </Col>
        <Col xs={4} md={4} lg={4}>
          <p>
            Approx Distance:{" "}
            <span className="fw-medium"> {data?.distance} KM </span>{" "}
          </p>
        </Col>
        {/* <Col xs={4} md={4} lg={4}>
          <p>Valid Upto: 29-mar-25</p>
        </Col> */}
        <Col xs={4} md={4} lg={4}>
          <p>
            Supply Type:{" "}
            <span className="fw-medium">{data?.supplyType} </span>{" "}
          </p>
        </Col>
        <Col xs={4} md={4} lg={4}>
          <p>
            Transaction Type:{" "}
            <span className="fw-medium">{data?.transactionType} </span>{" "}
          </p>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col xs={12} md={12} lg={12}>
          <p className="fw-bold fs-5">2.E-way Bill Details </p>
        </Col>
        {/* form and to addres */}
        <Col xs={6} md={6} lg={6}>
          <p className="fw-bold">From </p>
        </Col>
        <Col xs={6} md={6} lg={6}>
          <p className="fw-bold">To </p>
        </Col>

        <Col xs={6} md={6} lg={6}>
          {/* company From */}
          <span>
            {companyDetails?.address +" "}
          {companyDetails?.address2 +" "}
          {companyDetails?.cityPostalCode}

               </span>
                  </Col>
        <Col xs={6} md={6} lg={6}>
          {/* company To */}
          {data?.deliveryAddress+" "}
          {data?.deliveryState+" "}
          {data?.deliveryPinCode}
        </Col>
        {/* dispatch from to addres */}
        <Row className="my-4">
          <Col xs={6} md={6} lg={6}>
            <p className="fw-bold">Dispatch From</p>
          </Col>
          <Col xs={6} md={6} lg={6}>
            <p className="fw-bold">Ship To </p>
          </Col>
          <Col xs={6} md={6} lg={6}>
            {/* dispatch From */}
            {companyDetails?.address+" "}
            {companyDetails?.address2+" "}
            {companyDetails?.cityPostalCode}
          </Col>
          <Col xs={6} md={6} lg={6}>
            {/* ship To */}
            {data?.deliveryAddress+" "}
            {data?.deliveryState+" "}
            {data?.deliveryPinCode}
          </Col>
        </Row>
      </Row>

      <Row>
        <hr />
        <Col xs={12} md={12} lg={12}>
          <p className="fw-bold fs-5">3. Goods Details</p>
        </Col>
        <hr />
        <Col xs={12} md={12} lg={12}>
          <Row className="d-flex">
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">HSN Code </p>
              <p className="fw-bold fs-5">Product Name & Desc </p>
            </Col>
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-end gap-3"
            >
              <p className="fw-bold fs-5" style={{ marginRight: "16%" }}>
                {" "}
                Quntity{" "}
              </p>
              <p className="fw-bold fs-5" style={{ marginRight: "6%" }}>
                Taxable Amt{" "}
              </p>
              <p className="fw-bold fs-5 d-felx flex-column">
                <span>Tax Rate</span> <span className="d-block"></span>
              </p>
            </Col>
          </Row>
          <hr />
          <Row className="d-flex">
            {items?.map((item, i) => (
              <Row key={i}>
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  className="d-flex justify-content-start gap-3"
                >
                  <p className="fw-bold fs-5 me-4 pe-4">{item?.materialCode}</p>
                  <p className="fw-bold fs-5">{item?.materialDescription}</p>
                </Col>
                <Col
                  xs={6}
                  md={6}
                  lg={6}
                  className="d-flex justify-content-end gap-3"
                >
                  <p className="fw-bold fs-5" style={{ marginRight: "18%" }}>
                    <span className="mx-2"> {item?.orderedQuantity} </span>
                    {item?.orderUnitOfMeasure}{" "}
                  </p>
                  <p className="fw-bold fs-5" style={{ marginRight: "14%" }}>
                    {item?.taxAmount}{" "}
                  </p>
                  <p className="fw-bold fs-5 d-felx flex-column">
                    <span>{item?.taxPercentage} %</span>
                  </p>
                </Col>
              </Row>
            ))}
          </Row>
          <hr />
          <Row className="d-flex">
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">Toable Taxable Amt : </p>
              <p className="fw-bold fs-5">
                {parseFloat(data?.lineItemTaxTotal)}
              </p>
            </Col>
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-end gap-3"
            >
              <p className="fw-bold fs-5">Total amt :</p>
              <p className="fw-bold fs-5">{data?.lineItemGrossTotal ?? 0}</p>
            </Col>
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">CGSt amt :</p>
              <p className="fw-bold fs-5">{data?.totalCgst ?? 0} </p>
            </Col>
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-end gap-3"
            >
              <p className="fw-bold fs-5">SGSt amt :</p>
              <p className="fw-bold fs-5">{data?.totalSgst ?? 0} </p>
            </Col>
          </Row>

          <hr />
          <Row className="d-flex">
            <Col xs={12} md={12} lg={12} className="fs-5 fw-bold">
              {" "}
              4. Transportation Details
            </Col>
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">Transaction ID : </p>
            </Col>
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">Doc No. : </p>
            </Col>
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">Name : </p>
            </Col>
            <Col
              xs={6}
              md={6}
              lg={6}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">Date : </p>
            </Col>
          </Row>

          <hr />
          <Row className="d-flex">
            <Col xs={12} md={12} lg={12} className="fs-5 fw-bold">
              {" "}
              5. Vehicle Details
            </Col>
            <Col
              xs={4}
              md={4}
              lg={4}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5"> Vehicle No : </p>
              {/* <p className="fw-bold fs-5">
                {data?.items[0]?.loadingTruckNoDescription}{" "}
              </p> */}
            </Col>
            <Col
              xs={4}
              md={4}
              lg={4}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">From : </p>
              <p className="fw-bold fs-5">Bengaluru </p>
            </Col>
            <Col
              xs={4}
              md={4}
              lg={4}
              className="d-flex justify-content-start gap-3"
            >
              <p className="fw-bold fs-5">CEWB No. : </p>
              <p className="fw-bold fs-5"> </p>
            </Col>
          </Row>
          <hr />
        </Col>
      </Row>
    </div>
  );
});

export default ERFPrintEwayBill;
